<template>

    <div class="add_contacts_csv_container">

        <div class="title_add_contact">
            <div class="title_add_contact_icon_back" @click="$emit('backClicked')">
                <i class="zmdi zmdi-arrow-left"></i>
            </div>
            <h3 class="title is-size-5">
                {{ $t('components.shared.addContacts.importCsvTitle', {contactLabel: contactLabel}) }}
            </h3>
        </div>

        <p class="mini_notice">
            {{ $t('components.shared.addContacts.importCsvNotice', {contactLabel: contactLabel}) }}
        </p>

        <div class="file has-name file-input-container">
            <label class="file-label">
                <input type="file" class="file-input" @change="getFile" ref="csvFile">
                <span class="file-cta">
                    <span class="file-icon"><i class="zmdi zmdi-file"></i></span>
                    <span class="file-label">{{ $t('components.shared.addContacts.importCsvChooseFile') }}</span>
                </span>
                <span class="file-name">{{ fileName }}</span>
            </label>
        </div>
        <div class="csv_file_error" v-if="fileError">
            <strong>{{ $t('components.shared.addContacts.importCsvFileErrorTitle') }}</strong><br>
            {{ $t('components.shared.addContacts.importCsvFileErrorNotice') }}
        </div>

        <div class="control_table" v-if="(hasFile && !fileError && dataErrorCount > 0)">

            <!-- <div class="csv_check_notice">
                <strong>Fichier ok</strong><br>
                Le fichier à bien été importé. Vous pouvez vérifier les données extraites du fichier ci dessous<br>
                une fois les données vérifiées, vous pouvez cliquer sur Ajouter les {{ contactLabel }}s a la liste.
                Cliquez sur valider lorsque vous aurez terminé.
            </div> -->

            <div class="csv_data_errors">
                {{ $t('components.shared.addContacts.importCsvFileNumberErrorNotice', {dataErrorCount: dataErrorCount}) }}
            </div>
            <!-- <div class="send_contact_to_list" v-if="(dataErrorCount == 0)">
                <button class="button is-info is-outlined" @click="sendContactsToList">Ajouter les {{ contactLabel }}s a la liste</button>
            </div> -->
            <table class="csv_table table">
                <thead>
                    <tr>
                        <th>{{ $t('components.shared.addContacts.formFirstNameLabel') }}</th>
                        <th>{{ $t('components.shared.addContacts.formLastNameLabel') }}</th>
                        <th>{{ $t('components.shared.addContacts.formEmailLabel') }}</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(csvRow, index) in csv" :key="index">
                        <td :class="{'csv-has-error': isNameError(csvRow[0])}">{{ csvRow[0] }}</td>
                        <td :class="{'csv-has-error': isNameError(csvRow[1])}">{{ csvRow[1] }}</td>
                        <td :class="{'csv-has-error': isEmailError(csvRow[2])}">{{ csvRow[2] }}</td>
                    </tr>
                </tbody>
            </table>
        </div>

    </div>

</template>


<script>
import Papa from 'papaparse';
import { setTimeout } from 'timers';

export default {
    name: 'AddContactsCsv',
    props: {
        contactLabel: {
            type: String,
            default: 'contact'
        }    
    },
    components: {
        Papa
    },
    data(){
        return {
            parseCsv: null,
            hasFile: false,
            fileName: this.$i18n.t('components.shared.addContacts.noFileSelected'),
            fileError: false,
            dataErrorCount: false,
            csv: "",
            papaConfig: {
                header: false,
                skipEmptyLines: true
            }
        }
    },
    methods: {
        resetState(){
            this.parseCsv = null
            this.hasFile = false
            this.fileName = this.$i18n.t('components.shared.addContacts.noFileSelected')
            this.fileError = false
            this.dataErrorCount = false
            this.csv = ""
        },
        isEmailError(email){
            let reg = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/
            return (email == "" || !reg.test(email))
        },
        isNameError(name){
            return name == ''
        },
        getFile(){
            this.resetState()
            this.readFile((output) => {
                if (output){
                    this.csv = this._.get(Papa.parse(output, this.papaConfig), "data");
                    this.hasFile = true
                    this.checkDataErrors()
                    setTimeout(() => {
                        if (this.hasFile && !this.fileError && this.dataErrorCount == 0){
                            this.sendContactsToList()
                        }
                    }, 50)
                }else{
                    this.fileError = true
                }
            })
        },
        checkDataErrors(){
            this.csv.forEach( (csvRow) => {
                if (this.isNameError(csvRow[0])){ this.dataErrorCount++ }
                if (this.isNameError(csvRow[1])){ this.dataErrorCount++ }
                if (this.isEmailError(csvRow[2])){ this.dataErrorCount++ }
            })
        },
        readFile(callback) {
            let file = this.$refs.csvFile.files[0];
            if (file) {
                this.fileName = file.name
                if(file.type == "text/csv"){
                    this.fileError = false
                    let reader = new FileReader()
                    reader.readAsText(file, "UTF-8")
                    reader.onload = function (evt) { callback(evt.target.result) }
                    reader.onerror = function () { callback(false) }
                }else{
                    this.fileError = true
                }
            }else{
                this.fileError = true
            }
        },
        sendContactsToList(){
            const contactList = []
            this.csv.forEach( (csvRow) => {
                contactList.push({first_name: csvRow[0], last_name: csvRow[1], email: csvRow[2], docs_ids: []})
            })
            this.$emit("addCsvContactsToList", contactList)
            this.resetState()
        }
    }
}
</script>

<style lang="scss">
.file-name{
    border-radius: 3px;
}
.file-cta{
    border-radius: 3px;
}
.csv_file_error{
    padding: 12px 0;
    color: $danger;
    strong{
        color: $danger;
    }
}
.csv_data_errors{
    color: $danger;
}
.csv-has-error{
    background: $danger;
    color: white;
}
.csv_table{
    width: 100%;
}
.file-input-container{
    margin-top: 12px;
}
.csv_check_notice{
    padding: 12px 0;
    color: $success;
    strong{
        color: $success;
    }
}
</style>